module.exports = __webpack_public_path__ + "img/nocall.ed46f97c.png";